import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MOCK_USER_PROFILE } from './mock-data';
import { StoryContextService } from './story-context.service';

@Injectable({
  providedIn: 'root'
})
export class MockProfileService {
  // Story character names
  private storyNames: { [key: string]: { firstName: string; lastName: string } } = {
    'jon': { firstName: 'Jon', lastName: '' },
    'ben': { firstName: 'Ben', lastName: '' },
    'jane': { firstName: 'Jane', lastName: '' },
    'henry': { firstName: 'Henry', lastName: '' }
  };

  constructor(private storyContext: StoryContextService) {}

  getProfile(): Observable<any> {
    return this.storyContext.getCurrentStoryId().pipe(
      map(storyId => {
        if (storyId && this.storyNames[storyId]) {
          return {
            ...MOCK_USER_PROFILE,
            firstName: this.storyNames[storyId].firstName,
            lastName: this.storyNames[storyId].lastName
          };
        }
        return MOCK_USER_PROFILE;
      })
    );
  }

  updateProfile(profile: any): Observable<any> {
    return of({ ...MOCK_USER_PROFILE, ...profile });
  }
}

